import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Award, CheckCircle2 } from 'lucide-react';
import { aboutContent, businessInfo, galleryImages } from '../data/mock';
import './Pages.css';

const About = () => {
  return (
    <div className="page-about">
      {/* Hero Section */}
      <section className="about-hero section-padding">
        <div className="container">
          <div className="grid-two-column">
            <div>
              <h1 className="hero-medium">Precision Installation.<br />Premium Results.</h1>
              <p className="body-large space-top-lg text-secondary">
                {businessInfo.experience} specializing in high-end integrated appliances across Greater Vancouver and Fraser Valley.
              </p>
            </div>
            <div className="credentials-showcase">
              <div className="credential-item">
                <Shield size={32} />
                <div>
                  <h3 className="heading-3">{businessInfo.insurance}</h3>
                  <p className="body-small text-secondary">Your investment protected</p>
                </div>
              </div>
              <div className="credential-item">
                <Award size={32} />
                <div>
                  <h3 className="heading-3">{businessInfo.worksafe}</h3>
                  <p className="body-small text-secondary">Safe, compliant work</p>
                </div>
              </div>
              <div className="credential-item">
                <CheckCircle2 size={32} />
                <div>
                  <h3 className="heading-3">{businessInfo.gst}</h3>
                  <p className="body-small text-secondary">Fully registered business</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Owner Story */}
      <section className="section-padding owner-story-section">
        <div className="container">
          <div className="grid-two-column">
            <div className="story-image-container">
              <img 
                src={galleryImages[1].url} 
                alt="Joe's Premium Installation Work" 
                className="story-image"
              />
            </div>
            <div className="story-content">
              <h2 className="heading-1">Meet Joe Pauloski</h2>
              <div className="story-text space-top-lg">
                <p className="body-regular">
                  {aboutContent.story}
                </p>
              </div>
              <div className="experience-timeline space-top-xl">
                <div className="timeline-item">
                  <h4 className="heading-3">11 Years</h4>
                  <p className="body-small text-secondary">Total Industry Experience</p>
                </div>
                <div className="timeline-item">
                  <h4 className="heading-3">4 Years</h4>
                  <p className="body-small text-secondary">Appliance Delivery</p>
                </div>
                <div className="timeline-item">
                  <h4 className="heading-3">7 Years</h4>
                  <p className="body-small text-secondary">Specialized Installation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="section-padding values-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">What Sets Us Apart</h2>
          </div>
          
          <div className="values-grid space-top-xl">
            {aboutContent.values.map((value) => (
              <div key={value.title} className="value-card">
                <h3 className="heading-2">{value.title}</h3>
                <p className="body-regular text-secondary space-top-md">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Credentials List */}
      <section className="section-padding-small credentials-section">
        <div className="container">
          <div className="credentials-grid">
            <div>
              <h2 className="heading-1">Credentials & Insurance</h2>
              <p className="body-regular text-secondary space-top-md">
                Professional qualifications that protect your investment
              </p>
            </div>
            <div>
              <ul className="credentials-list">
                {aboutContent.credentials.map((credential) => (
                  <li key={credential} className="credential-list-item">
                    <CheckCircle2 size={20} className="credential-icon" />
                    <span className="body-regular">{credential}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Showcase */}
      <section className="section-padding">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">Recent Work</h2>
            <p className="body-regular text-secondary space-top-sm">
              Premium installations across Greater Vancouver and Fraser Valley
            </p>
          </div>
          
          <div className="portfolio-showcase space-top-xl">
            {galleryImages.map((image) => (
              <div key={image.id} className="portfolio-item">
                <img src={image.url} alt={image.alt} className="portfolio-image" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="hero-medium">Let's Talk About Your Project</h2>
            <p className="body-large space-top-md">
              Get a professional assessment and detailed quote
            </p>
            <div className="space-top-lg">
              <Link to="/contact" className="btn-primary">
                Request a Quote
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
